import React, {Component} from 'react';
import {View, TouchableOpacity, I18nManager, ActivityIndicator, Image, Platform, Alert} from 'react-native';
import {moderateScale} from "../../../../tools/Scaling";
import * as NavigationService from '../../../../redux/NavigationService';
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import {connect} from "react-redux";
import i18n from "../../../../I18n/i18n";
import {Tools} from "../../../../tools/Tools";
import PathFile from "../../../../assets/PathFile";
import HMIcon from "../../../../customviews/HMIcon";

class AdapterListOperatorFireApply extends Component {

    componentWillMount() {

    }

    constructor(props) {
        super(props);
    }

    state = {
        indexLoading: -1
    }

    componentWillReceiveProps(propss) {

    }

    componentWillUnmount() {

    }

    setData(item) {
        //   this.props.callService(Contants.urlSetMyApplyScreen, `?property=${data.id}&apply_notify=${!(data.apply_notify)}&token=${this.props.DataSplashScreen.token}`, Contants.TypeSetMyApplyScreen, 'POST', 0, 0, data.id)

    }

    /*  isCherries(fruit) {
         return fruit.name === 'cherries';
     }*/
    render() {
        let {item, index, navigation, item_parent, hiddenModal, offline, listTask} = this.props;
        let data = this.props.item;
        let fileAudio = data.audio || data.audio === null ? data.audio : (data.files && data.files.length > 0 && (data.files.find(k => k.type === 'audio/aac')))
        let fileImage = data.image || data.image === null ? data.image : (data.files && data.files.length > 0 && (data.files.find(k => k.type === 'image/jpeg')))
        let fileVideo = data.video || data.video === null ? data.video : (data.files && data.files.length > 0 && (data.files.find(k => k.type === 'video/mp4')))
        return (


            <TouchableOpacity style={{
                width: "98%",
                alignSelf: "center",
                paddingHorizontal: moderateScale(4),
                marginHorizontal: moderateScale(8)
            }}
                              onPress={() => {
                                  //  this.props.callServiceShowWebView("")
                                  NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                                      index: index,
                                      item: item,
                                      offline: offline,
                                      listTask: offline ? listTask : []
                                  })
                                  //hiddenModal()
                              }}
                //onPress={() =>NavigationService.navigateParams("VideoScreen", {id: data.id}) }

            >
                <View style={{
                    padding: moderateScale(6),
                    // flexDirection: "row",
                    // width: "100%",
                    flex: 1,
                    marginVertical: moderateScale(4),
                    borderRadius: moderateScale(5),
                    backgroundColor: Colors.backgroundColor,

                    // justifyContent: "flex-end"
                }}>

                    <View style={{flex: 1, flexDirection: 'row',}}>
                        <View style={{flexDirection: 'row', flex: .33,}}>
                            <HMTextView type={"bold"}

                                        style={{
                                            fontSize: moderateScale(16),
                                            marginHorizontal: moderateScale(5),
                                            color: Colors.blackLight,
                                            // marginTop: moderateScale(10)
                                        }}
                                // text={"1423578"}
                                        text={data.TrackingCode ? data.TrackingCode : (I18nManager.getConstants().isRTL ? " ." + (index + 1) : (index + 1) + " .")}
                                //   text={"98/03/21"}
                            />
                        </View>
                        <View style={{
                            flex: .33, flexDirection: 'row',
                            // alignItems: 'center',
                            justifyContent: 'center'
                            //    backgroundColor:'#96ee5b'
                        }}>
                            <HMTextView
                                //type={"bold"}

                                style={{
                                    fontSize: moderateScale(13),
                                    color: Colors.colorDark,
                                    textAlign: 'center',
                                    //alignSelf:'center',
                                    // marginTop: moderateScale(10)
                                }}
                                //  text={'1398/05/03'}
                                text={data.DateTimeJalali ? data.DateTimeJalali : data.date}
                                //   text={"98/03/21"}
                            />
                        </View>
                        <View style={{flexDirection: 'row', flex: .33, justifyContent: 'flex-end'}}>
                            {
                                <TouchableOpacity
                                    onPress={() => {
                                        Tools.GoLink(data.CallerID, "phone")
                                    }}
                                    style={{flexDirection: 'row',}}>

                                    <HMTextView
                                        type={"bold"}


                                        style={{
                                            fontSize: moderateScale(13),

                                            color: Colors.blue,
                                            // marginHorizontal:moderateScale(1)
                                            // marginTop: moderateScale(10)
                                        }}
                                        text={data.CallerID}
                                        //   text={"98/03/21"}
                                    />
                                    {/* <HMIcon name={"md-call"} style={{
                                        alignSelf: 'center',
                                        // width: moderateScale(14),
                                        color: Colors.blue,
                                        fontSize: Platform.OS === 'ios' ? moderateScale(14) : moderateScale(12),
                                        textAlign: 'center'
                                    }}/>*/}
                                </TouchableOpacity>

                                // <HMTextView type={"bold"}
                                //
                                //             style={{
                                //                 fontSize: moderateScale(10),
                                //                 color: data.color ? data.color : Colors.gray,
                                //                 // marginTop: moderateScale(10)
                                //             }}
                                //             text={data.status}
                                //     //   text={"98/03/21"}
                                // />


                            }

                        </View>
                    </View>
                    <View
                        style={{
                        flex: 1,
                        padding: moderateScale(4),
                            marginVertical:moderateScale(2),
                        //    justifyContent: 'flex-end'
                    }}>
                        <HMTextView
                            type={"bold"}

                            style={{
                                fontSize: moderateScale(13),
                                color: Colors.colorDark,
                                // marginTop: moderateScale(10)
                            }}
                            //text={'آسیب های اجتماعی'}
                            text={data.SubjectName ? data.SubjectName : data.category}
                            //   text={"98/03/21"}
                        />

                        {/* <HMTextView
                            //type={"bold"}


                            style={{
                                fontSize: moderateScale(11),

                                color: Colors.gray,
                                // marginTop: moderateScale(10)
                            }}
                            text={data.Address}
                            //   text={"98/03/21"}
                        />*/}
                    </View>
                    <View style={{width: '100%', flexDirection: 'row',  marginVertical:moderateScale(2),}}>
                        <View
                            style={{flexDirection: "row", alignItems: 'center', flex: .5}}>
                            <Image
                                source={PathFile.image.fire_symbol}
                                //resizeMode="stretch"
                                style={[{}, {


                                    //   margin: moderateScale(5),
                                    width: moderateScale(18),
                                    height: moderateScale(18),

                                    tintColor: !item.ReachTime || item.ReachTime == "" ? Colors.gray : Colors.green

                                }]}/>

                            <View style={{width: moderateScale(8)}}/>
                            <HMTextView
                                text={!item.ReachTime || item.ReachTime == "" ? i18n.t('constant.NotRegistered') : item.ReachTime}
                                style={{
                                    marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    color: "grey"
                                }}/>

                        </View>
                        <View
                            style={{flexDirection: "row", alignItems: 'center', flex: .5}}>
                            <Image
                                source={PathFile.image.fire_clock}
                                //resizeMode="stretch"
                                style={[{}, {


                                    //   margin: moderateScale(5),
                                    width: moderateScale(18),
                                    height: moderateScale(18),

                                    tintColor: !item.FireTime || item.FireTime == "" ? Colors.gray : Colors.green

                                }]}/>

                            <View style={{width: moderateScale(8)}}/>
                            <HMTextView
                                text={!item.FireTime || item.FireTime == "" ? i18n.t('constant.NotRegistered') : item.FireTime}
                                style={{
                                    marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    color: "grey"
                                }}/>

                        </View>
                    </View>
                    <View style={{width: '100%', flexDirection: 'row',  marginVertical:moderateScale(2),}}>
                        <View
                            style={{flexDirection: "row", alignItems: 'center', flex: .5}}>
                            <Image
                                source={PathFile.image.fire_clock2}
                                //resizeMode="stretch"
                                style={[{}, {


                                    //   margin: moderateScale(5),
                                    width: moderateScale(18),
                                    height: moderateScale(18),

                                    tintColor: !item.ReturnTime || item.ReturnTime == "" ? Colors.gray : Colors.green

                                }]}/>

                            <View style={{width: moderateScale(8)}}/>
                            <HMTextView
                                text={!item.ReturnTime || item.ReturnTime == "" ? i18n.t('constant.NotRegistered') : item.ReturnTime}
                                style={{
                                    marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    color: "grey"
                                }}/>

                        </View>
                        <View
                            style={{flexDirection: "row", alignItems: 'center', flex: .5}}>
                            <Image
                                source={PathFile.image.fire_weather}
                                //resizeMode="stretch"
                                style={[{}, {


                                    //   margin: moderateScale(5),
                                    width: moderateScale(18),
                                    height: moderateScale(18),

                                    tintColor: !item.StateMelkDetail || item.StateMelkDetail == "" ? Colors.gray : Colors.green

                                }]}/>

                            <View style={{width: moderateScale(8)}}/>
                            <HMTextView
                                text={!item.StateMelkDetail || item.StateMelkDetail == "" ? i18n.t('constant.NotCompleted') : i18n.t('constant.Completed')}
                                style={{
                                    marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    color: "grey"
                                }}/>

                        </View>

                    </View>
                    <View style={{width: '100%', flexDirection: 'row',  marginVertical:moderateScale(2),}}>
                        <View
                            style={{flexDirection: "row", alignItems: 'center', flex: .5}}>
                            <Image
                                source={PathFile.image.fire_remove}
                                //resizeMode="stretch"
                                style={[{}, {


                                    //   margin: moderateScale(5),
                                    width: moderateScale(18),
                                    height: moderateScale(18),

                                    tintColor: !item.StateInformation || item.StateInformation == "" ? Colors.gray : Colors.green

                                }]}/>

                            <View style={{width: moderateScale(8)}}/>
                            <HMTextView
                                text={!item.StateInformation || item.StateInformation == "" ? i18n.t('constant.NotCompleted') : i18n.t('constant.Completed')}
                                style={{
                                    marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    color: "grey"
                                }}/>

                        </View>
                        <View
                            style={{flexDirection: "row", alignItems: 'center', flex: .5}}>
                            <Image
                                source={PathFile.image.fire_file}
                                //resizeMode="stretch"
                                style={[{}, {


                                    //   margin: moderateScale(5),
                                    width: moderateScale(18),
                                    height: moderateScale(18),

                                    tintColor: !item.CountAnswers || item.CountAnswers == "" ? Colors.gray : Colors.green

                                }]}/>

                            <View style={{width: moderateScale(8)}}/>
                            <HMTextView
                                text={!item.CountAnswers || item.CountAnswers == "" ? i18n.t('constant.NotRegistered') : item.CountAnswers}
                                style={{
                                    marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    color: "grey"
                                }}/>

                        </View>


                    </View>
                    <View style={{width: '100%', flexDirection: 'row',  marginVertical:moderateScale(2),}}>
                        <View
                            style={{flexDirection: "row", alignItems: 'center', flex: .5}}>
                            <Image
                                source={PathFile.image.fire_shape}
                                //resizeMode="stretch"
                                style={[{}, {


                                    //   margin: moderateScale(5),
                                    width: moderateScale(18),
                                    height: moderateScale(18),

                                    tintColor: !item.CountDamage || item.CountDamage == "" ? Colors.gray : Colors.green

                                }]}/>

                            <View style={{width: moderateScale(8)}}/>
                            <HMTextView
                                text={!item.CountDamage || item.CountDamage == "" ? i18n.t('constant.NotRegistered') : item.CountDamage}
                                style={{
                                    marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    color: "grey"
                                }}/>

                        </View>
                        <View
                            style={{flexDirection: "row", alignItems: 'center', flex: .5}}>
                            <Image
                                source={PathFile.image.fire_extinguisher}
                                //resizeMode="stretch"
                                style={[{}, {


                                    //   margin: moderateScale(5),
                                    width: moderateScale(18),
                                    height: moderateScale(18),

                                    tintColor: !item.CountTools || item.CountTools == "" ? Colors.gray : Colors.green

                                }]}/>

                            <View style={{width: moderateScale(8)}}/>
                            <HMTextView
                                text={!item.CountTools || item.CountTools == "" ? i18n.t('constant.NotRegistered') : item.CountTools}
                                style={{
                                    marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    color: "grey"
                                }}/>

                        </View>


                    </View>

                    <View
                        onPress={() => {
                            NavigationService.navigateParams("ShowMap", {
                                myLocation: true,
                                position: {
                                    coords: {
                                        latitude: item.Latitude,
                                        longitude: item.Longitude
                                    }
                                }
                            })

                        }}
                        style={{flexDirection: "row", alignItems: 'center',  marginVertical:moderateScale(2),}}>
                        <HMIcon type={"Feather"}                                                 name={"map-pin"} style={{
                            fontSize: moderateScale(18),
                            color: item.Latitude && item.Latitude != null && item.Latitude != '' && item.Latitude != 0 ? Colors.green : Colors.gray
                        }}/>
                        <View style={{width: moderateScale(8)}}/>
                        <HMTextView
                            text={item.Address}
                            style={{
                                marginEnd: moderateScale(10),
                                fontSize: moderateScale(14),
                                color: "grey"
                            }}/>

                    </View>


                    {/*<View style={{flex: 1, flexDirection: 'row',}}>*/}
                    {/*<View style={{flex: .7, flexDirection: 'row',}}>*/}
                    {/*{*/}

                    {/*<TouchableOpacity style={{*/}
                    {/*//flex: .3,*/}
                    {/*flexDirection: 'row',*/}

                    {/*alignItems: 'center',*/}
                    {/*justifyContent: 'center',*/}
                    {/*marginHorizontal: moderateScale(5)*/}
                    {/*}}>*/}
                    {/*<HMIcon name={"md-pin"} style={{*/}
                    {/*alignSelf: 'center',*/}
                    {/*// width: moderateScale(14),*/}
                    {/*color: data.latitude && data.latitude != null && data.latitude != '' ? Colors.colorPrimaryDark : Colors.gray,*/}
                    {/*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*/}
                    {/*textAlign: 'center'*/}
                    {/*}}/>*/}
                    {/*</TouchableOpacity>*/}

                    {/*}*/}

                    {/*{*/}

                    {/*<TouchableOpacity style={{*/}
                    {/*// flex: .33,*/}

                    {/*flexDirection: 'row',*/}
                    {/*alignItems: 'center',*/}
                    {/*justifyContent: 'center',*/}
                    {/*marginHorizontal: moderateScale(5)*/}
                    {/*}}>*/}
                    {/*<HMIcon name={"md-image"} style={{*/}
                    {/*alignSelf: 'center',*/}
                    {/*// width: moderateScale(14),*/}
                    {/*color: ((data.files && data.files.length > 0 && fileImage && fileImage.file) || data.image) ? Colors.colorPrimaryDark : Colors.gray,*/}
                    {/*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*/}
                    {/*textAlign: 'center'*/}
                    {/*}}/>*/}
                    {/*</TouchableOpacity>*/}

                    {/*}*/}
                    {/*{*/}


                    {/*<TouchableOpacity style={{*/}
                    {/*// flex: .33,*/}
                    {/*flexDirection: 'row',*/}
                    {/*alignItems: 'center',*/}
                    {/*justifyContent: 'center',*/}
                    {/*marginHorizontal: moderateScale(5)*/}
                    {/*}}>*/}
                    {/*<HMIcon name={"md-videocam"} style={{*/}
                    {/*alignSelf: 'center',*/}
                    {/*// width: moderateScale(14),*/}
                    {/*color: ((data.files && data.files.length > 0 && fileVideo && fileVideo.file) || data.video) ? Colors.colorPrimaryDark : Colors.gray,*/}
                    {/*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*/}
                    {/*textAlign: 'center'*/}
                    {/*}}/>*/}
                    {/*</TouchableOpacity>*/}

                    {/*}*/}
                    {/*{*/}


                    {/*<TouchableOpacity style={{*/}
                    {/*// flex: .33,*/}
                    {/*flexDirection: 'row',*/}
                    {/*alignItems: 'center',*/}
                    {/*justifyContent: 'center',*/}
                    {/*marginHorizontal: moderateScale(5)*/}
                    {/*}}>*/}
                    {/*<HMIcon name={"md-mic"} style={{*/}
                    {/*alignSelf: 'center',*/}
                    {/*// width: moderateScale(14),*/}
                    {/*color: ((data.files && data.files.length > 0 && fileAudio && fileAudio.file) || data.audio) ? Colors.colorPrimaryDark : Colors.gray,*/}
                    {/*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*/}
                    {/*textAlign: 'center'*/}
                    {/*}}/>*/}
                    {/*</TouchableOpacity>*/}

                    {/*}*/}

                    {/*</View>*/}
                    {/*{*/}
                    {/*data._operation ?*/}
                    {/*<View style={{flex: .3, flexDirection: 'row', justifyContent: 'flex-end'}}/>*/}
                    {/*:*/}
                    {/*<View style={{flex: .3, flexDirection: 'row', justifyContent: 'flex-end'}}>*/}
                    {/*<HMIcon name={"ios-text"} style={{*/}
                    {/*alignSelf: 'center',*/}
                    {/*// width: moderateScale(14),*/}
                    {/*color: Colors.colorDark,*/}
                    {/*marginHorizontal: moderateScale(5),*/}
                    {/*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*/}
                    {/*textAlign: 'center'*/}
                    {/*}}/>*/}
                    {/*<HMTextView*/}

                    {/*//type={"bold"}*/}
                    {/**/}
                    {/*style={{*/}
                    {/*fontSize: moderateScale(11),*/}
                    {/*color: Colors.gray,*/}

                    {/*// marginTop: moderateScale(10)*/}
                    {/*}}*/}
                    {/*text={data.lastWork && data.lastWork.length > 0 ? data.lastWork.length : 0}*/}
                    {/*//   text={"98/03/21"}*/}
                    {/*/>*/}
                    {/*</View>*/}
                    {/*}*/}

                    {/*</View>*/}


                </View>
            </TouchableOpacity>


        );
    }

}

const mapStateToProps = state => {
    return {

         results: state.reducerListOperatorFireApplyScreen.results,
        // isLoadingSet: state.reducerMyApplyScreen.isLoadingSet,
        // NoInternetDialogSet: state.reducerMyApplyScreen.NoInternetDialogSet,
        // token: state.reducerSplashGetAllData.token,
        // DataSplashScreen: state.reducerSplashGetAllData,
        // id: state.reducerMyApplyScreen.id,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        // callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(url, params, type, typeConnection, page, item_count, id)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(AdapterListOperatorFireApply);
